/** @format */

import WidgetFormattedNumber from 'components/PropertyWidget/components/WidgetFormattedNumber';
import {WidgetStat} from 'components/PropertyWidget/model';
import {ValueBox} from 'components/PropertyWidget/style';

export interface GetStatsTypeGoalOptions {
  avgPerDay: number;
  sumForPeriod: number;
}

const getStatsTypeGoal = ({avgPerDay, sumForPeriod}: GetStatsTypeGoalOptions): WidgetStat[] => {
  return [
    {
      heading: 'Ср. в день',
      ValueComponent: (
        <ValueBox>
          <WidgetFormattedNumber number={avgPerDay} roundNumberBy={1} />
        </ValueBox>
      ),
    },
    {
      heading: 'За период',
      ValueComponent: (
        <ValueBox>
          <WidgetFormattedNumber number={sumForPeriod} roundNumberBy={0} />
        </ValueBox>
      ),
    },
  ];
};

export default getStatsTypeGoal;
